<template>
  <div class="tab-body">
    <div class="operator">
      {{ msg }}
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData.records"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="tid" width="130" label="月份"></el-table-column>
        
        <el-table-column
          prop="name"
          width="150"
          label="申请人"
        ></el-table-column>

      

        <el-table-column
          prop="cost"
          width="220"
          label="报销合计金额(元)"
        >
        <template slot-scope="scope">
             {{ scope.row.cost.toFixed(2) }}
          </template>
      </el-table-column>

        <el-table-column
          prop="appendix"
          width="100"
          label="含报销数"
        ></el-table-column>

        <el-table-column
          prop="state"
          width="90"
          label="状态"
        >
        <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.state === 2">待发放</el-tag>
            <el-tag size="mini" v-if="scope.row.state === 4" type="success">已发放 </el-tag>
          </template>
      
      </el-table-column>

        <el-table-column prop="mdtm" label="发放/审批通过时间"></el-table-column>
       
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>



    </div>
  </div>
</template>
<script>
import api from "@/api/cw/reimburses.js";

export default {
  name: "riemscomt",
  components: {},
  data() {
    return {
  
      listLoading: false,
 
      listData: [],
      selected: [],
      cwcnts:[],
      paytm:"",
      cpttpname:"",
      sumPay: 0,
      sumVal: 0,
      msg: "" ,
      page: new this.$constant.pageObj(),
    };
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;

      api.listCount(this.page, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      this.sumVal = 0;
      this.sumPay = 0;

      for (let item of val) {
        this.selected.push(item.bxemp);
        this.sumVal += item.cost * 1;
        if (item.state==4) {
          this.sumPay += item.cost * 1;
        }
      }

      if (this.selected.length > 0) {
        this.msg =
          "  已选择: " +
          this.selected.length +
          " 人次, 报销合计: " +
           this.sumVal.toFixed(2) +
          " 元, 其中已发放:" +
          this.sumPay +
          "元、 待发："+( this.sumVal - this.sumPay).toFixed(2)+" 元";
      } else {
        this.msg = "";
        this.sumPay = 0;
        this.sumVal = 0;
        this.selected=[]
      }
    }, //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

  },
  mounted() {
      this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.operator {
  margin-top: 4px;
}
.errorClass {
  margin-top: 4px;
}
</style>

